import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';

class AlertDismissable extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.handleDismiss = this.handleDismiss.bind(this);

        this.state = {
            show: true
        };
    }

    handleDismiss() {
        this.setState({ show: false });
    }

    render() {
        const { bsStyle } = this.props;
        return (this.state.show && (
            <Alert bsStyle={bsStyle} onDismiss={this.handleDismiss} >
                {this.props.children}
            </Alert>
        ));
    }
}

export default AlertDismissable;